<template>
    <div class="row">
        <div class="col-md-6 col-md-offset-3 text-center">
            <l-space :size="1" />

            <img src="@/img/icons/reviews.png" alt="Reviews" width="150" />
            <br />
            <h4 class="color-grey"><l-text :text="$t(`reviews.admin.analyticsEmptyH1`)" /></h4>
        </div>
    </div>
</template>

<script>
import LSpace from "@/components/LSpace";
import LText from "@/components/LText";

export default {
    components: {
        LSpace,
        LText,
    },
};
</script>
